import React, { useEffect, useRef } from "react";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useFormContext } from "react-hook-form";

function WebsiteGoals(props) {
  const { nextStep, prevStep } = props;
  
  const {
    register,
    watch,
    setValue,
    trigger,
    formState: { errors },
    getValues,
  } = useFormContext();



  

  return (
    <>
      <div className="w-full space-y-5">
        <div className="space-y-5">
          <div className="space-y-8 mt-4">
            <div>
              <label className="text-lg text-gray-500">Website Purpose *</label>

              <input
                type="text"
                name="website_purpose "
                placeholder="e.g. e-commerce, informational, portfolio, etc."
                className="outline-none border-b w-full py-2 text-sm"
                {...register("website_purpose", {
                  required: "Please specify the purpose of your website.",
                     validate: (v) =>
      v.trim() !== "" || "Please specify the purpose of your website.",  
                })}
              />
              {errors.website_purpose && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.website_purpose.message}
                </p>
              )}
            </div>
            <div>
              <label className="text-lg text-gray-500">Must-have pages *</label>

              <input
                type="text"
                name="must_have_pages"
                placeholder=" e.g. home, about, services, shop, contact, etc."
                className="outline-none border-b w-full py-2 text-sm"
                {...register("must_have_pages", {
                  required: "Please list the essential pages you want on your website.",
                     validate: (v) =>
      v.trim() !== "" || "Please list the essential pages you want on your website.",  
                })}
              />
              {errors.must_have_pages && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.must_have_pages.message}
                </p>
              )}
            </div>
            <div>
              <label className="text-lg text-gray-500">Any specific features to be included </label>

              <input
                type="text"
                name="specific_features"
                placeholder="e.g. social media feeds, customized forms, user sign-in "
                className="outline-none border-b w-full py-2 text-sm"
                {...register("specific_features", {
                  required: "Please describe the features you'd like to include.",
                     validate: (v) =>
      v.trim() !== "" || "Please describe the features you'd like to include.",  
                })}
              />
              {errors.specific_features && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.specific_features.message}
                </p>
              )}
            </div>
            
          </div>
        </div>
        <div className="flex justify-between items-center">
            <button className="p-0 text-gray-500" onClick={() => {
                                          
                                          prevStep();
                                               if (typeof window !== "undefined") {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }
                                      }}
                                      ><FaArrowLeftLong /></button>
          <button
            className=" bg-[#FFC067] text-dark font-bold  rounded px-6 py-3 text-base md:text-lg hover:bg-[#DF73FF]  transition ease-in duration-300 cursor-pointer "
            onClick={async () => {
              const isValid = await trigger([
                "website_purpose",
                "must_have_pages",
                "specific_features",
              ]);
              if (isValid) {
                nextStep();
                     if (typeof window !== "undefined") {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }
              }
            }}
          >
            Next
          </button>
        </div>
      </div>
    </>
  );
}

export default WebsiteGoals;
